export enum ColonistMembershipPerkType {
    AllMaps,
    AllExpansions,
    PremiumMatchmaking,
    CustomLinks,
    ColonistCoins,
    NoAds,
    AllColors,
    BasicReplay,
    FullReplay,
}
